import { Factory } from 'miragejs';
import faker from 'faker';
import ENV from 'dashboard/config/environment';

export default Factory.extend({
  firstName() {
    return faker.name.firstName();
  },
  lastName() {
    return faker.name.lastName();
  },
  email() {
    return `${this.firstName.toLowerCase()}.${this.lastName.toLowerCase()}@getshowbie.com`;
  },
  avatarUrl() {
    return ENV.APP.defaultAvatarUrl;
  },
});
